import {
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'

import { AreaType } from '@/types/areaZone'
import { FC } from 'react'
import AreasAndZonesTableRow from './AreasAndZonesTableRow'
import classes from './styles.module.scss'

interface AreasAndZonesProps {
  data?: AreaType[]
  totalCount?: number
}

const AreaTable: FC<AreasAndZonesProps> = ({ data, totalCount }) => {
  return (
    <Stack
      flexGrow="1"
      className={classes.stackWra}
      justifyContent="space-between"
    >
      <TableContainer component={Paper} elevation={0}>
        <Table aria-label="simple table" className={classes.table}>
          <TableHead
            sx={{
              backgroundColor: '#EFEFEF',
              fontWeight: 600,
              borderBottom: '1px solid #D7D7D7',
            }}
          >
            <TableRow>
              <TableCell>
                <Typography className={classes.headFirstCell}>Areas</Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody sx={{ backgroundColor: 'common.white' }}>
            {data &&
              data.length > 0 &&
              data.map((row, index) => (
                <AreasAndZonesTableRow key={row.id} row={row} />
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  )
}

export default AreaTable
